import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { ApiAsset } from "../_types/assets.types";

type Meta = { total: number; page: number; limit: number; totalPages: number };

export const useAssetsQuery = (params: {
  page: number;
  limit: number;
  kind?: string;
  q?: string;
}) => {
  return useQuery({
    queryKey: ["assets", params],
    queryFn: async () => {
      const response = await axiosInstance.get<ApiResponse<ApiAsset[], Meta>>(
        "/v2/assets",
        {
          params: {
            page: params.page,
            limit: params.limit,
            kind:
              params.kind && params.kind !== "all" ? params.kind : undefined,
            q: params.q,
          },
        },
      );
      const items = response.data.data ?? [];
      const meta = response.data.meta ?? {
        total: items.length,
        page: params.page,
        limit: params.limit,
        totalPages: 1,
      };
      return { items, meta };
    },
  });
};
